import {AfterViewInit, Component, ContentChild, Input, OnDestroy, OnInit, TemplateRef} from '@angular/core';
import {ContentDirective} from '../../../../shared/directives/content.directive';
import {Sort, UrlParameter} from '../../../../shared/utils/url.builder';
import {Page} from '../../../../shared/model/core/page.model';
import {Subscription} from 'rxjs';
import {AbstractFindManyPaginatedService} from '../../service/v2/service/findmany/abstractFindManyPaginated.service';
import {Pageable} from '../../../../shared/model/core/pageable.model';

@Component({
    selector: 'app-datatable-data',
    templateUrl: './datatable-data.component.html',
})
export class DatatableDataComponent<T> implements OnInit, AfterViewInit, OnDestroy {

    @Input() pageSize = undefined;
    @Input() noResultLabel = 'Aucun résultat';
    @Input() parameters: UrlParameter[];
    @Input() sort: Sort;
    @Input() loadPageOnInit = true;
    @Input() paginatedService: AbstractFindManyPaginatedService<any, T>;

    @ContentChild(ContentDirective, {static: true, read: TemplateRef}) template: TemplateRef<any>;

    error = false;
    loading = false;
    page: Page<T>;

    subscriptions: Subscription[] = [];

    constructor() {
    }

    ngOnInit() {
        this.subscriptions.push(this.paginatedService.loading$.subscribe(value => this.loading = value));
        this.subscriptions.push(this.paginatedService.error$.subscribe(value => this.error = !!value));
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(this.paginatedService.page$.subscribe(value => {
            this.page = value;
        }));


        if (this.loadPageOnInit) {
            this.findPaginated(0);
        }

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(value => value.unsubscribe());
    }

    next(page: Page<T>) {
        this.findPaginated(page.number + 1);
    }

    previous(page: Page<T>) {
        this.findPaginated(page.number - 1);
    }

    findPaginated(pageNumber: number) {
        this.paginatedService.findPaginated(Pageable.ofWithSort(pageNumber, this.pageSize, this.sort), this.parameters);
    }
}
